(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-order-form"] && !Shopify.designMode) return;
  try {
    
function initializeTdaSizeGuide() {
  const select = document.getElementById('tda-size-preference');
  const guide = document.getElementById('tda-size-guide');
  if (!select || !guide || select.dataset.guideReady) return;
  select.dataset.guideReady = 'true';
  const cards = guide.querySelectorAll('[data-size-example]');
  function showExamples() {
    const selected = select.value;
    const specific = ['Small', 'Medium', 'Large'].includes(selected);
    cards.forEach(card => { card.hidden = specific && card.dataset.sizeExample !== selected; });
    guide.toggleAttribute('data-filtered', specific);
    if (selected) guide.open = true;
  }
  select.addEventListener('change', showExamples);
  guide.querySelectorAll('[data-choose-size]').forEach(button => {
    button.addEventListener('click', () => {
      select.value = button.dataset.chooseSize;
      select.dispatchEvent(new Event('change', {bubbles:true}));
      select.focus({preventScroll:true});
    });
  });
  showExamples();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeTdaSizeGuide);
else initializeTdaSizeGuide();
document.addEventListener('shopify:section:load', initializeTdaSizeGuide);

function initializeTdaOrderSteps() {
  const steps = document.querySelector('.tda-order-steps');
  if (!steps || steps.dataset.ready) return;
  steps.dataset.ready = 'true';
  const desktop = window.matchMedia('(min-width: 990px)');
  function updateStepsLayout() { steps.open = desktop.matches; }
  updateStepsLayout();
  desktop.addEventListener('change', updateStepsLayout);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeTdaOrderSteps);
else initializeTdaOrderSteps();
document.addEventListener('shopify:section:load', initializeTdaOrderSteps);

function initializeTdaGuideDialog() {
  const dialog = document.getElementById('tda-guide-dialog');
  const launch = document.querySelector('.tda-guide-launch');
  if (!dialog || !launch || dialog.dataset.dialogReady) return;
  dialog.dataset.dialogReady = 'true';
  const video = dialog.querySelector('video');
  launch.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); });
  dialog.querySelector('.tda-guide-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { video.pause(); });
  dialog.addEventListener('click', event => {
    const bounds = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeTdaGuideDialog);
else initializeTdaGuideDialog();
document.addEventListener('shopify:section:load', initializeTdaGuideDialog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  function updateTdaCartCount(count) {
    const cartCount = document.getElementById('tda-cart-count');

    if (!cartCount) return;

    const itemCount = Number(count) || 0;

    cartCount.textContent =
      itemCount > 99
        ? '99+'
        : itemCount > 0
          ? itemCount
          : '';
  }

  document.addEventListener('cart:updated', function (event) {
    const count =
      event &&
      event.detail &&
      typeof event.detail.item_count !== 'undefined'
        ? event.detail.item_count
        : 0;

    updateTdaCartCount(count);
  });

});


  } catch(e) { console.error(e); }
})();
})();
